export default __webpack_public_path__ + "static/media/plus-activity-points.b0e8125d.svg";